import { render } from "./NavbarComponent.vue?vue&type=template&id=505c1eb4&scoped=true"
import script from "./NavbarComponent.vue?vue&type=script&lang=js"
export * from "./NavbarComponent.vue?vue&type=script&lang=js"

import "./NavbarComponent.vue?vue&type=style&index=0&id=505c1eb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505c1eb4"]])

export default __exports__